import { C as CosmosIconShop$1, d as defineCustomElement$1 } from './p-BQy_8EAL.js';

const CosmosIconShop = CosmosIconShop$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconShop, defineCustomElement };
